import { IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import React, { useContext } from "react";
import { Route } from "react-router-dom";
import { AuthenticatedUserContext } from "../contexts/AuthenticatedUserContext";
import AppUrlListener from "../listeners/AppUrlListener";
import { Pending } from "../pages/Pending";
import SignOut from "../pages/SignOut/SignOut";

export const LoggedInUnapprovedRouter = (props: any) => {
  const { member } = useContext(AuthenticatedUserContext);
  return (
    <IonReactRouter>
      <AppUrlListener />
      <IonRouterOutlet id="main">
        <Route
          path="/"
          render={() => {
            return <Pending status={member?.status} />;
          }}
          exact
        />
        <Route path="/sign-out" component={SignOut} exact />
      </IonRouterOutlet>
    </IonReactRouter>
  );
};
